import { createSlice } from "@reduxjs/toolkit";

const initialState = [
  ["Project Overview", false, false],
  ["PV Configuration", false, false],
  ["Detail Structure Layout", false, false],
  ["PV Module Details", true, false],
  ["Production Forecast", true, false],
  ["Building Consumption Analysis", true, false],
  ["Simulation Results", true, false],
  ["Production Forecast With Consumption", true, false],
  ["Energy Loss Analysis", true, false],
  ["Financial Analysis", true, false],
  ["Return on Investment", true, false],
  ["Inverter Configuration", true, false],
  ["Electrical Equipment Details", true, false],
  ["Environmental Details", true, false],
  [
    "Product Data Sheets",
    true,
    false,
    [
      ["Structure Data Sheets", true],
      ["Inverter Data Sheets", true],
      ["Panel Data Sheets", true],
    ],
  ],
];

export const reportFeatures = createSlice({
  name: "reportFeatures",
  initialState: initialState,
  reducers: {
    updateReportFeatures: (state, action) => {
      return action.payload;
    },
  },
});

export const { updateReportFeatures } = reportFeatures.actions;

export default reportFeatures.reducer;
